<div class="challenge-assets-content">
  <div class="challenge-assets-content--loading" *ngIf="loading">
    <p>Loading datasets and models…</p>
  </div>
  <!-- Datasets Section -->
  <div class="challenge-assets-content--section" *ngIf="!loading && datasets.length > 0">
    <h6 class="challenge-assets-content--heading">Datasets</h6>
    <div class="challenge-assets-content--carousel-wrapper">
      <app-carousel 
        [items]="datasets" 
        [itemsToShow]="3"
        [showDots]="true"
        [showArrows]="true"
        [gap]="24"
      >
        <div 
          *ngFor="let dataset of datasets; let i = index" 
          class="carousel-item"
        >
          <app-asset-card
            [data]="dataset"
            assetType="dataset"
            variant="challenge"
            [previewMode]="previewMode"
          ></app-asset-card>
        </div>
      </app-carousel>
    </div>
  </div>

  <!-- Models Section -->
  <div class="challenge-assets-content--section" *ngIf="!loading && models.length > 0">
    <h6 class="challenge-assets-content--heading">Models</h6>
    <div class="challenge-assets-content--carousel-wrapper">
      <app-carousel 
        [items]="models" 
        [itemsToShow]="3"
        [showDots]="true"
        [showArrows]="true"
        [gap]="24"
      >
        <div 
          *ngFor="let model of models; let i = index" 
          class="carousel-item"
        >
          <app-asset-card
            [data]="model"
            assetType="model"
            variant="challenge"
            [previewMode]="previewMode"
          ></app-asset-card>
        </div>
      </app-carousel>
    </div>
  </div>

  <!-- Empty State -->
  <div class="challenge-assets-content--empty" *ngIf="!loading && datasets.length === 0 && models.length === 0">
    <p>No datasets or models associated with this challenge.</p>
  </div>
</div>


